

module.exports = __webpack_require__.stylable.create(
    "ScrollableTabs1298180585",
    {"classes":{"root":"ScrollableTabs1298180585__root","nav":"ScrollableTabs1298180585__nav","tab":"ScrollableTabs1298180585__tab","selectedIndicator":"ScrollableTabs1298180585__selectedIndicator","border":"ScrollableTabs1298180585__border","itemsList":"ScrollableTabs1298180585__itemsList"},"vars":{},"stVars":{"scrollAnimationDuration":".4s","selectedIndicatorColor":"--overridable"},"keyframes":{}},
    "",
    2,
    "ScrollableTabs1298180585",
    null
);
